const SORTING_ICONS = {
  SORTING: require('@/assets/sorting.svg'),
  SORTING_UP: require('@/assets/sorting_up.svg'),
  SORTING_DOWN: require('@/assets/sorting_down.svg')
}


export default SORTING_ICONS